import { HTMLAttributes } from "react";

interface YouthSportsIconProps extends HTMLAttributes<SVGElement> {}

const YouthSportsIcon = ({}: YouthSportsIconProps) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Whistle">
        <path
          id="Vector"
          d="M3.18483 6.70211C4.98694 4.87705 7.90873 4.87705 9.71083 6.70211C10.2085 7.20607 10.5687 7.79646 10.7915 8.42559C15.2881 6.6097 20.5885 7.45334 24.3383 10.9565L24.7206 11.3283L39.0779 25.8685C39.7341 26.533 39.7845 27.6098 39.2293 28.3378L39.0779 28.5122L35.1622 32.4776C34.5888 33.0583 33.7172 33.186 33.0123 32.8181L32.8063 32.6928L26.1921 28.0553C25.7613 28.6811 25.2707 29.2769 24.7206 29.834C19.6747 34.9442 11.4937 34.9442 6.44779 29.834C2.25365 25.5864 1.54566 19.1452 4.32386 14.157C3.91377 13.9416 3.5289 13.6597 3.18483 13.3112C1.38273 11.4862 1.38273 8.52717 3.18483 6.70211ZM20.1524 15.9679C17.6295 13.4128 13.539 13.4128 11.016 15.9679C8.49308 18.5229 8.49308 22.6656 11.016 25.2206C13.539 27.7758 17.6295 27.7758 20.1524 25.2206C22.6755 22.6656 22.6755 18.5229 20.1524 15.9679Z"
          stroke="#048CDD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default YouthSportsIcon;
